<template>
  <div
    class="card-selection"
    v-on:click="$emit('selectedOption') ? $emit('selectedOption') : ''"
    v-bind:class="{
      'card-selection--active': activeValue
    }"
  >
    {{ text }}
  </div>
</template>

<script>
export default {
  props: { text: String, activeValue: Boolean }
};
</script>

<style lang="scss" scoped>
.card-selection {
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px,
    rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
  margin: 10px;
  padding: 10px 15px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  text-transform: uppercase;

  &--active {
    background-color: #150b0b;
    color: #fff;
  }
}
</style>
